export default __webpack_public_path__ + "static/media/white-lightning.2be39253.svg";